/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './app.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from './ui/header/header.component.ngfactory';
import * as import3 from '../../app/ui/header/header.component';
import * as import4 from '../../app/notification/notification.service';
import * as import5 from '../../app/booking-management/booking-header/booking-header.service';
import * as import6 from '../../app/api/messaging.service';
import * as import7 from '@angular/common';
import * as import8 from '@angular/router';
import * as import9 from '../../app/shared/user-name.service';
import * as import10 from '../../app/shared/router/linkhelper';
import * as import11 from '../../app/shared/sub-organisation-filter/sub-organisation-filter.service';
import * as import12 from './notification/notification.component.ngfactory';
import * as import13 from '../../app/notification/notification.component';
import * as import14 from './spinner/spinner.component.ngfactory';
import * as import15 from '../../app/spinner/spinner.component';
import * as import16 from './screen-guard/screen-guard.component.ngfactory';
import * as import17 from '../../app/screen-guard/screen-guard.component';
import * as import18 from '../../app/spinner/spinner.service';
import * as import19 from '../../app/api/user.service';
import * as import20 from '../../app/app.component';
import * as import21 from '@angular/platform-browser';
import * as import22 from '@angular/material';
import * as import23 from '../../app/shared/popup/popup.service';
const styles_AppComponent:any[] = [import0.styles];
export const RenderType_AppComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_AppComponent,
  data: {}
}
);
function View_AppComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-header',([] as any[]),(null as any),(null as any),(null as any),import2.View_HeaderComponent_0,import2.RenderType_HeaderComponent)),
    import1.ɵdid(245760,(null as any),0,import3.HeaderComponent,[
      import4.NotificationServiceBus,
      import5.BookingHeaderService,
      import1.NgZone,
      import6.MessagingService,
      import7.Location,
      import8.Router,
      import9.UserNameService,
      import10.LinkAuth,
      import11.SubOrganisationFilterService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export function View_AppComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-notification',([] as any[]),(null as any),(null as any),(null as any),import12.View_NotificationComponent_0,import12.RenderType_NotificationComponent)),
    import1.ɵdid(245760,(null as any),0,import13.NotificationComponent,[
      import4.NotificationServiceBus,
      import1.NgZone
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-spinner',([] as any[]),(null as any),(null as any),(null as any),import14.View_SpinnerComponent_0,import14.RenderType_SpinnerComponent)),
      import1.ɵdid(180224,(null as any),0,import15.SpinnerComponent,([] as any[]),{isRunning: [
        0,
        'isRunning'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'app-screen-guard',([] as any[]),(null as any),(null as any),(null as any),import16.View_ScreenGuardComponent_0,import16.RenderType_ScreenGuardComponent)),
    import1.ɵdid(245760,(null as any),0,import17.ScreenGuardComponent,[
      import8.Router,
      import18.SpinnerService,
      import19.UserService,
      import4.NotificationServiceBus,
      import1.NgZone
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted(0,['\n    '])),
    (l()(),import1.ɵand(16777216,(null as any),0,1,(null as any),View_AppComponent_1)),
    import1.ɵdid(16384,(null as any),0,import7.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted(0,['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),0,0,'div',[[
        'class',
        'background-fill'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted(0,['\n\n    '])),
    (l()(),import1.ɵeld(16777216,(null as any),0,1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(147456,(null as any),0,import8.RouterOutlet,[
      import8.RouterOutletMap,
      import1.ViewContainerRef,
      import1.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted(0,['\n']))
  ]
  ,(ck,v) => {
    var co:import20.AppComponent = v.component;
    ck(v,1,0);
    const currVal_0:any = co.isRequesting;
    ck(v,4,0,currVal_0);
    ck(v,7,0);
    const currVal_1:any = co.isLoggedIn();
    ck(v,10,0,currVal_1);
  },(null as any));
}
function View_AppComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-root',([] as any[]),(null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
    import1.ɵdid(245760,(null as any),0,import20.AppComponent,[
      import18.SpinnerService,
      import21.Title,
      import8.Router,
      import22.MdDialog,
      import23.PopupService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:import1.ComponentFactory<import20.AppComponent> = import1.ɵccf('app-root',import20.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9hcHAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzIiwibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzLkFwcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxhcHAtbm90aWZpY2F0aW9uPjwvYXBwLW5vdGlmaWNhdGlvbj5cclxuPGFwcC1zcGlubmVyIFtpc1J1bm5pbmddPVwiaXNSZXF1ZXN0aW5nXCI+PC9hcHAtc3Bpbm5lcj5cclxuXHJcbjxhcHAtc2NyZWVuLWd1YXJkPlxyXG4gICAgPGFwcC1oZWFkZXIgKm5nSWY9XCJpc0xvZ2dlZEluKClcIiA+PC9hcHAtaGVhZGVyPlxyXG4gICAgPGRpdiBjbGFzcz1cImJhY2tncm91bmQtZmlsbFwiPjwvZGl2PlxyXG5cclxuICAgIDxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD5cclxuPC9hcHAtc2NyZWVuLWd1YXJkPiIsIjxhcHAtcm9vdD48L2FwcC1yb290PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDSUk7Z0JBQUE7Ozs7Ozs7Ozs7SUFBQTtLQUFBOzs7SUFBQTs7Ozs7SUFKSjtnQkFBQTs7O0lBQUE7S0FBQTtJQUFxQztJQUNyQztrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXNEO0lBRXREO2dCQUFBOzs7Ozs7SUFBQTtLQUFBO0lBQWtCO0lBQ2Q7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUErQztNQUMvQztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1DO0lBRW5DO2dCQUFBOzs7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUErQjs7OztJQVBuQztJQUNhO0lBQWIsU0FBYSxTQUFiO0lBRUE7SUFDZ0I7SUFBWixVQUFZLFNBQVo7Ozs7O0lDSko7Z0JBQUE7Ozs7OztJQUFBO0tBQUE7OztJQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts